import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Link
} from 'react-router-dom'
import $ from 'jquery';
import './App.css';
import MainHeader from './components/header';
import MainFooter from './components/Core/footer';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as ReactBootstrap from 'react-bootstrap';

class Home extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.testing);
        this.state = {isToggleOn: true, store: this.props.store, fullQual: "undefined", test: "Not Defined", provider: "The TransactionID is "};
    }

    componentWillMount() {
        var globalThis = this;


            ///either pass guid in urlParams or generate in javascript.
            var tempID = "No TID";
            // $.ajax({
            //     url: 'http://www.mealtrist.com/profilefeedapi/1',
            //     type: 'GET',
            //     success: function (data) {
            //         console.log(data);
            //     }
            // });

    }


    render() {
        console.log(ReactBootstrap);
        let redirect = null;
        if (this.state.test !== "Not Defined") {
            redirect = <Redirect to="/login"/>;
        } else {
            redirect =
                <div>
                <MainHeader/>
                    <div id="banner" className="upper">
                        <div className="meal-banner">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-7 col-lg-6 col-lg-offset-1" id="slideDiv"><h3 className="animated slideInLeft text-center" id="textTitle"><strong>Mealtrist - A Simple, Social, Meal Planning App</strong></h3>
                                        <ul className="col-sm-offset-2 col-sm-10 col-xs-12">
                                            <li className="animated slideInRight" id="promise1"><i className="fa fa-check"></i> Upload Your Meals with Ingredients</li>
                                            <li className="animated slideInLeft" id="promise2"><i className="fa fa-check"></i> Save and Share Meals with Your Friends</li>
                                            <li className="animated slideInRight" id="promise3"><i className="fa fa-check"></i> Build your meal plan, and we will generate your grocery list from the ingredients!</li>
                                        </ul>
                                    </div>
                                    <div className="col-md-5 col-sx-12">

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="container-fluid">
                        <h2 id="head-banner">The Best Meal Planning Web App - Free!</h2>
                    </div>

                    <div id="main-content" className="container">
                        <h2 className="text-center color-black">How It Works</h2>
                        <ReactBootstrap.Tabs defaultActiveKey={1} animation={false} id="noanim-tab-example">
                            <ReactBootstrap.Tab eventKey={1} title="Upload Meals">
                                <div className="row">
                                    <h2 className="text-center">Upload Your Meals With Ingredients</h2>
                                    <p className="lead">The good news is that you will only have to do this once. That's right. Get all of your meals together and put them into our system so we can make meal planning fun and easy. There are apps out there that try to do this for you,
                                        but fail miserably. There are tools out there that try to calculate your grocery list, but then you end up getting about five different
                                        milks for 1 cup here and a few ounces there. If you upload your grocery lists our way, then you will have no problem getting a clean list
                                        with the right calculations. Simply drag and drop meals to plan your week. It doesn't get any easier than that.
                                    </p>
                                </div>
                            </ReactBootstrap.Tab>
                            <ReactBootstrap.Tab eventKey={2} title="Save & Share">
                                <div className="row">
                                    <h2 className="text-center">Save and Share Meals with Your Friends</h2>
                                    <p className="lead">Okay, so this is more than just calculating your meals. In the meal planning process we find ourselves looking for new delicious meals
                                        to add to our regular routine. We want to sort out what meals are quick, easy, and tasty and which ones are to die for, but take a little longer
                                        to make. We know we're probably not going to schedule those meals when time is limited during the workweek. Mealtrist solves that problem. Have you ever wanted to
                                        see your friends meals, save the ones you like with a click, and then add then add them to your shopping list with another click. That's the
                                        incredible functionality that Mealtrist brings to your life. Your Meals, Your Interests - Mealtrist. Give us a chance, help us make it even better, join the community!
                                    </p>
                                </div>
                            </ReactBootstrap.Tab>
                            <ReactBootstrap.Tab eventKey={3} title="Generated Grocery List">
                                <div className="row">
                                    <h2 className="text-center">Build your meal plan and we will generate your grocery list from the ingredients</h2>
                                    <h2 className="pad-1">Save Folders</h2>
                                    <p className="lead">Alright, here is where it gets cool. After you click a meal to save it. It goes into your saved meals page. From there you can organize it however you like. It has a similar look
                                        to folders that you might see on a computer. You can organize by chicken meals, holidays, by the time it takes to prep and cook the meals. It is really up to you! The
                                        power is in your hands.
                                    </p>
                                    <h2 className="pad-1">Planning Page</h2>
                                    <p className="lead">Now remember the folders with all those saved meals? They show up on the planning page and you simply click the day of the week you want to plan for, then choose if you want to add to breakfast,
                                        lunch, and dinner. Then fill the day with delights. At the bottom of the page you will see that there is a list of ingredients for your next shopping trip.
                                        {/*Uh oh! But what happens when I had a snack or something I want for the week that isn't an ingredient or even a food product? Well, there is*/}
                                        {/*a button that allows for you to add any item to your list by name and amount. */}
                                        {/*At last, when you get to the grocery store... no more pen and paper! Open your plan page*/}
                                        {/*and all you have to do to check off from your grocery list is to swipe right for "green" which means your have it in your cart or left for "red", which means*/}
                                        {/*you do not have that item in your cart. */}
                                        Mealtrist makes eveything easy.
                                    </p>

                                </div>
                            </ReactBootstrap.Tab>
                        </ReactBootstrap.Tabs>;
                    </div>
                    <MainFooter/>
            </div>
        }

        return (
            redirect
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setOffers: (offers) => {
            dispatch(toggleTodo(offers))
        },
        setParams: (params) => {
            dispatch(setParams(params))
        }
    }
};

function setParams(params) {
    return { type: "INIT_PARAMS", initParams: params }
}

function toggleTodo(offers) {
    return { type: "SET_OFFERS", offerResponse: offers }
}


const mapStateToProps = state => {
    return {
        state
    }
}

export default Home = connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/App.js